module.exports = __webpack_public_path__ + "static/img/pharmacy_map.34bc8df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc_barocare_conci/sub5/pharmacy_map.png
// module id = mk2Z
// module chunks = 0